import { render, staticRenderFns } from "./PagesAccess.vue?vue&type=template&id=5bdca86a&scoped=true&"
import script from "./PagesAccess.vue?vue&type=script&lang=js&"
export * from "./PagesAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdca86a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bdca86a')) {
      api.createRecord('5bdca86a', component.options)
    } else {
      api.reload('5bdca86a', component.options)
    }
    module.hot.accept("./PagesAccess.vue?vue&type=template&id=5bdca86a&scoped=true&", function () {
      api.rerender('5bdca86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin-access/PagesAccess.vue"
export default component.exports